/**
 * Paleta de Cores - Tema evolv (Painel Web)
 */

const color1 = '#14532D'   // Verde escuro (brand principal)
const color2 = 'white'
const color3 = '#22C55E'   // Verde evolv (ação/destaque)
const color4 = '#71cddc'
const color5 = '#444'
const color6 = '#16A34A'   // Verde médio (hover/active)
const color7 = '#67b8c7'   // Azul apoio
const color8 = 'brown'     // Alerta


const COLORS = {
    GREEN: {
        100: '#DCFCE7',
        200: '#BBF7D0',
        300: '#86EFAC',
        400: '#4ADE80',
        500: '#22C55E', 
        600: '#16A34A', 
        700: '#15803D',
        800: '#166534',
        900: '#14532D',
    },
    RED: {
        100: '#faebeb',
        200: '#efc2c2',
        300: '#e59999',
        400: '#db7171',
        500: '#d04848',
        600: '#d04848',
        650: '#cb1a1a',
        700: '#8e2424',
        800: '#661a1a',
        900: '#3d1010',
    },
    BLUE: {
        100: '#ebf8fa',
        200: '#c2e9f0',
        300: '#99dbe6',
        400: '#70cddc',
        500: '#47bed2',
        600: '#2da5b8',
        700: '#23808f',
        800: '#195b66',
        900: '#0f373d',
    },
    GRAY: {
        50: '#fafafa',
        100: '#f4f4f5',
        200: '#e4e4e7',
        300: '#d4d4d8',
        400: '#a1a1aa',
        500: '#71717a',
        600: '#52525b',
        700: '#3f3f46',
        800: '#27272a',
        900: '#18181b'
    }
}

const styles = {

    tc1: color1, //text
    tc2: color2,
    tc3: color3,
    tc4: color4,

    bc1: color1, //backgound
    bc2: color2,
    bc3: color3,
    bc4: color4,
    bc6: color6,
    bc7: color7,
    bc8: color8,

    bt3: color3, //button
    bt5: color5,
    bt6: color6,
    bt7: color7,

    COLORS
}


export default styles
